import React, { useEffect, useState } from "react";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { saveAnswer } from "../../../slices/answerSlice";

const McqCard = ({ data, sNo }) => {
  const [selectedOption, setSelectedOption] = useState('');
  const dispatch = useDispatch();
  const answerState = useSelector((state) => state.answer);

  const handleOptionSelect = (questionId, selected) => {
    dispatch(saveAnswer({ questionId: questionId, selectedOption: selected }));
    setSelectedOption(selected);
  };

  useEffect(() => {
    // Check if there is a saved answer for this question in the Redux state
    const savedAnswer = answerState.find(answer => answer.questionId === data._id);

    if (savedAnswer) {
      setSelectedOption(savedAnswer.selectedOption);
    }
  }, [data._id, answerState]);

  return (
    <div className="mcqCard" id={`question${sNo}`}>
      <h3 className="mcqSno">Question {sNo}</h3>
      <p className="mcqQuestion">{data.question}</p>
      <br />
      <div className="mcqOptions">
        {data.options.map((option, index) => (
          <div
            className={`mcqOption`}
            onClick={() => handleOptionSelect(data._id, option)}
            style={{
              cursor: selectedOption ? "" : "pointer",
            }}
          >
            <div
              id="optionCheckBox"
              style={{
                backgroundColor:
                  selectedOption === option
                    ? "var(--orange)"
                    : "var(--background-color)",
              }}
            ></div>
            <div className="mcqOptionText">{option}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default McqCard;
